/**
 *
 * ButtonLoader
 *
 */

import React, { memo } from 'react';

import LoadingIconWhite from '../../../images/loading-icon.svg';
import useStyles from './styles';

/**
 * @internal
 */
function ButtonLoader() {
  const classes = useStyles();

  return <img alt="" className={classes.root} src={LoadingIconWhite} />;
}

/**
 * @internal
 */
export default memo(ButtonLoader);
